import { render, staticRenderFns } from "./IncidentCreate.vue?vue&type=template&id=423ec026&scoped=true"
import script from "./IncidentCreate.vue?vue&type=script&lang=js"
export * from "./IncidentCreate.vue?vue&type=script&lang=js"
import style0 from "./IncidentCreate.vue?vue&type=style&index=0&id=423ec026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ec026",
  null
  
)

export default component.exports